import { useEffect, useRef, useState } from 'react';

export function useNetworkStatus(onReconnect?: () => void): { isOnline: boolean } {
  const [isOnline, setIsOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );
  const previousOnlineRef = useRef(isOnline);
  const onReconnectRef = useRef(onReconnect);
  onReconnectRef.current = onReconnect;

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleStatusChange = (nextOnline: boolean) => {
      const wasOnline = previousOnlineRef.current;
      previousOnlineRef.current = nextOnline;
      setIsOnline(nextOnline);

      if (!wasOnline && nextOnline) {
        void onReconnectRef.current?.();
      }
    };

    const handleOnline = () => handleStatusChange(true);
    const handleOffline = () => handleStatusChange(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
}
